// src/pages/Benefits/BenefitsPageStyles.ts
const styles = {
  QuestionairesContainer: {
    backgroundColor: "#f5f7fa",
    padding: "24px",
  },
  QuestionairesContent: {
    padding: '24px',
  },
  addButton: {
    marginBottom: '16px',
    backgroundColor: '#5958e1',
    '&:hover': {
      backgroundColor: '#5958c0',
    },
  },

  createButton: {
    backgroundColor: "#5958e1",
    "&:hover": {
      backgroundColor: "#4a49b3",
    },
  },
  tabs: {
    marginBottom: "16px",
    "& .MuiTab-root": {
      fontWeight: "bold",
    },
  },
};

export default styles;
